// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {TrainingRoom} from "@models";
import {SimTrainingRoomService} from "@services";
import {Translations} from "@translations";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {VMAutoCompleteNormal} from "../../../../../shared/shared-components/sim-advanced-inputs/sim-base-chip-input/sim-base-chip-input.component";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_CreateVirtualRoomInput extends MatDialogDataBaseInput {}

export interface DialogData_CreateVirtualRoomOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-create-virtual-room-dialog",
	templateUrl: "./create-virtual-room-dialog.component.html",
	styleUrls: ["./create-virtual-room-dialog.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 175}), zoomOutOnLeaveAnimation({duration: 175})],
	standalone: false,
})
export class CreateVirtualRoomDialogComponent extends BasicMaterialDialog<
	CreateVirtualRoomDialogComponent,
	DialogData_CreateVirtualRoomInput,
	DialogData_CreateVirtualRoomOutput
> {
	T = Translations;
	createVirtualRoomForm = new FormGroup({
		roomName: new FormControl("", [Validators.required]),
		combinedRooms: new FormArray<FormControl<TrainingRoom>>([]),
	});

	public onceCreation: boolean = true;

	constructor(
		_injector: Injector,
		private _simTrainingRoomService: SimTrainingRoomService,
	) {
		super(_injector);
	}

	createVirtualRoom() {
		this.onceCreation = false;
		const containedRoomIds = this.createVirtualRoomForm.controls.combinedRooms.value.map((room) => {
			return room.id;
		});

		this._simTrainingRoomService
			.createVirtualRoom({
				containedRoomIds: containedRoomIds,
				name: this.createVirtualRoomForm.controls.roomName.value,
			})
			.then((_) => {
				this.close({action: "ok"});
				this.onceCreation = true;
			});
	}

	cancel() {
		this.close({action: "cancel"});
	}
}
